import * as React from "react";

import SvgIcon from "@material-ui/core/SvgIcon";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

export const TrashIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <rect fill="none" width="20" height="20" />
                    <path d="M14.86,17.66H4.94V5.76h9.92Zm-8.72-1.2h7.52V7H6.14Z" />
                    <rect x="4.07" y="4.22" width="11.66" height="1.2" />
                    <polygon points="13.11 4.82 11.91 4.82 11.91 3.23 7.89 3.23 7.89 4.82 6.69 4.82 6.69 2.03 13.11 2.03 13.11 4.82" />
                    <rect x="7.63" y="6.37" width="1.2" height="10.69" />
                    <rect x="10.98" y="6.37" width="1.2" height="10.69" />
                </g>
            </g>
        </SvgIcon>
    );
};
